import { RoutingService } from "./RoutingService.js";
import { haversine } from "./utils.js";

export class ORSRoutingService extends RoutingService {
  constructor(endpoint, nonce) {
    super();
    if (!endpoint) {
      throw new Error("Route planner REST endpoint is missing.");
    }
    this.endpoint = endpoint;
    this.nonce = nonce || "";
  }

  async getSegment({ type, from, to }) {
    const headers = {
      "Content-Type": "application/json",
    };

    if (this.nonce) {
      headers["X-WP-Nonce"] = this.nonce;
    }

    const response = await fetch(this.endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers,
      body: JSON.stringify({ type, from, to }),
    });

    const data = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(data?.message || `Route request failed (${response.status}).`);
    }

    const coordinates = Array.isArray(data?.coordinates) ? data.coordinates.filter(isValidPoint) : [];
    if (coordinates.length < 2) {
      throw new Error("The routing service returned an incomplete segment.");
    }

    return {
      type: data.type === "manual" ? "manual" : "routed",
      fallback: Boolean(data.fallback),
      distance: Number.isFinite(data.distance) ? data.distance : calculateDistance(coordinates),
      coordinates,
    };
  }
}

function isValidPoint(point) {
  return Number.isFinite(point?.latitude) && Number.isFinite(point?.longitude);
}

function calculateDistance(points) {
  let distance = 0;
  for (let index = 1; index < points.length; index += 1) {
    distance += haversine(points[index - 1], points[index]);
  }

  return distance;
}
